import {Component, inject} from '@angular/core'
import {propertiesWithDoubleKalpAndApprovedWithoutOldProperty} from '@sparbanken-syd/loan-backend'
import {PropertyTypePipe} from '../../../pipes/property-type.pipe'
import {LoanService} from '../../../services/loan.service'
import {KalpItemComponent} from '../kalp-item/kalp-item.component'

@Component({
  selector: 'spb-kalp-new-property',
  templateUrl: './new-property.component.html',
  styleUrls: ['../kalp.component.scss'],
  imports: [KalpItemComponent, PropertyTypePipe]
})
export class NewPropertyComponent {
  public readonly loanService = inject(LoanService)
  protected readonly propertiesWithDoubleKalpAndApprovedWithoutOldProperty = propertiesWithDoubleKalpAndApprovedWithoutOldProperty
}
